<template>
	<img :src="src" alt="" :style="{width:w+'px',height:h+'px'}" @click="refreshSrc">
</template>
<script>
	export default{
		name:"",
		props:['width','height','refresh'],
		data(){
			return {
				w:100,
				h:44,
				src:'',
			}
		},
		
		methods:{
			refreshSrc(){
				let rand = Math.random();
				this.src = '/VerificationCode/image?w='+this.w+'&h='+this.h+'&rand='+rand;
			}
		},
		created(){
			if(this.width) this.w = this.width;
			if(this.height) this.h = this.height;
			this.refreshSrc();
		},
	}
</script>
<style scoped>
	img{
		cursor: pointer;
	}
</style>